/*
 * Site menu module
*/ 

rs.module("controls/navigation/sitemenu", 
    
    [
        "layouts/site-shell", 
        "common/perfect-scrollbar",
        "ui/framework/userstate-manager"],

    function (shell, perfectScrollbar, userStateManager) {

        var _menu;
        var _container;
        var _sidebar;

        var _jsSelectors;
        var _cssClasses;
        var _userStateKeys;

        var _scrollbars;
        var _heightAdjuster;

        var _updateScrollbarsEventName = "site-menu:update-scrollbars";

        // Initialize the site menu
        function initialize(jsSelectors, cssClasses, userStateKeys) {

            _jsSelectors = jsSelectors;
            _cssClasses = cssClasses;
            _userStateKeys = userStateKeys;

            _menu = $.js(jsSelectors.menu);
            _container = _menu.js(jsSelectors.menuContainer);
            _sidebar = _menu.js(jsSelectors.sidebar);

            // Listen for expand\collapse clicks
            _sidebar.js(jsSelectors.sidebarCollapse).on("click", _onCollapseToggle);

            // Create our scrollbars
            _scrollbars = perfectScrollbar.createInstance(_sidebar.js(jsSelectors.sidebarScrollbox), { suppressScrollX: true });

            // Prepare the height adjuster
            _updateHeightAdjuster();

            // We need to listen for and readjust if the shell changes its footer display
            shell.footerDisplayChanged(_onShellFooterDisplayChanged);
        }

        // The user is clicking to expand or collapse the menu
        function _onCollapseToggle() {
            var previous = _menu.hasClass(_cssClasses.collapsed);

            _menu.toggleClass(_cssClasses.collapsed, !previous);

            // Toggle the title (tool tip) for Collapse/Expand
            _sidebar.js(_jsSelectors.sidebarCollapse).attr("title", !previous ? "Expand" : "Collapse");

            // Persist the state
            userStateManager.persist(_userStateKeys.sidebarCollapsed, !previous);

            // Changing the collapsed state can cause heights to change, but not in a way that triggers
            // a browser scroll event that we are listening to - so we have to force this here.  Needs a slight
            // delay to wait for css animation\transitions to complete.
            setTimeout(_updateHeightAdjuster, 500);
        }

        //
        // Update the height adjuster function based on changes to the footer and menu display types
        //
        function _updateHeightAdjuster() {

            const _jQueryNamespace = ".site-menu";

            if (shell.footerDisplay == "standard") {

                if (!_heightAdjuster) {
                    _heightAdjuster = _createHeightAdjustor();
                    $(window).on(`resize${_jQueryNamespace} scroll${_jQueryNamespace}`, _heightAdjuster);
                }

                _heightAdjuster();
            }
            else {

                if (_heightAdjuster) {

                    _heightAdjuster.off();
                    $(window).off(_jQueryNamespace);

                    _heightAdjuster = null;
                }
            }
        }

        // Callback for when the footer display type of the shell has changed
        function _onShellFooterDisplayChanged() {
            _updateHeightAdjuster();
        }

        // Function that creates a function that will adjust the height
        // of the menu section to allow for scrolling
        function _createHeightAdjustor() {
            var win = $(window);
            var doc = $(document);
            var footer = shell.bottom;

            var adjustor = function () {

                var footerTop = footer.offset().top - doc.scrollTop();
                var menuBottom = Math.max(win.height() - footerTop, 0).toFixed(0) + "px";

                if (_container.css("bottom") != menuBottom) {

                    _container.css("bottom", menuBottom);

                    // Scrollbars have to be told to refresh themselves
                    _scrollbars.update();

                    // Also notify listeners that updates to the scrollbars may be required
                    _menu.trigger(_updateScrollbarsEventName);
                }
            };

            adjustor.off = function () {
                _container.css("bottom", "");
            };

            return adjustor;
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            updateScrollbars: function (handler) { _menu.on(_updateScrollbarsEventName, handler); }
        };

        return exports;
    }
);